import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { MdMenu } from 'react-icons/md';
import Sidebar from '../components/owner/Sidebar';
import { PanelToastProvider } from '../context/PanelToastContext';
import { usePlatformSettings } from '../context/PlatformSettingsContext';
import { warmOwnerPanelData } from '../services/panelBootstrap';
import OfflineStatusBanner from '../components/shared/OfflineStatusBanner';
import './OwnerLayout.css';
import '../styles/panelShared.css';
import '../pages/owner/ownerPanel.css';

function OwnerLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { softwareName } = usePlatformSettings();

  useEffect(() => {
    warmOwnerPanelData();
  }, []);

  return (
    <PanelToastProvider>
      <div className="owner-layout">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="owner-main">
          <OfflineStatusBanner />
          <header className="owner-topbar">
            <button
              type="button"
              className="sidebar-toggle"
              onClick={() => setSidebarOpen(true)}
              aria-label="Open menu"
            >
              <MdMenu />
            </button>
            <span className="owner-topbar-label">{softwareName || 'Owner Panel'}</span>
          </header>
          <main className="owner-content">
            <Outlet />
          </main>
        </div>
      </div>
    </PanelToastProvider>
  );
}

export default OwnerLayout;
